/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import Paper from '@base/Paper/Paper';
import { breakpoints } from '@styles/index';
import { getImage } from '@utils/imageHelper';
import styled from '@emotion/styled';

const Container = styled(Paper)`
  padding: 0 16px 16px !important;
  max-height: 60vh;
`;

const Header = styled.p`
  @media (max-width: ${breakpoints.mobile}) {
    font-size: 16px;
    line-height: 150%;
  }
`;

const Cover = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  left: 0;
  height: 56px;
  padding: 0 16px;
  z-index: 1000;
  background: var(--color-i-white);
  box-shadow: inset 0px -1px 0px rgb(60 72 82 / 12%);
`;

const Content = styled.div`
  padding-top: 56px;
  margin-top: 16px;
`;

const Button = styled.button`
  border: none;
  background: transparent;
  padding: 0;
`;

function LearnMore({ handleClose, children }) {
  return (
    <Container>
      <Cover>
        <Header>Best in class experience</Header>
        <Button onClick={handleClose}>
          <img
            src={getImage('k12/close.png')}
            alt="close"
            width="24"
            height="24"
            loading="lazy"
          />
        </Button>
      </Cover>
      <Content>{children}</Content>
    </Container>
  );
}

LearnMore.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  handleClose: PropTypes.func.isRequired
};

export default LearnMore;
